import usePreinfoButtons from "../../hooks/QuizPage/usePreinfoButtons"
import { TwoColumnGrid } from "../common/Buttons"
import {
  TextDiv,
  // UnderlinedTextButton
} from "../common/Text"
import { motion } from "framer-motion"
import styled from "styled-components"

interface Props {
  setModalShow: React.Dispatch<React.SetStateAction<boolean>>
}

const MajorSelector = ({ setModalShow }: Props) => {
  return (
    <Container>
      <TextDiv fontSize={20} $align="start" fontWeight="bold">
        결정한 계열이 있습니까?
      </TextDiv>
      <TwoColumnGrid>{usePreinfoButtons("대분류")}</TwoColumnGrid>
      {/* <SearchModalButton
        fontSize={13}
        color="var(--custom-blue)"
        onClick={() => setModalShow(true)}
      >
        결정한 과는 있는데, 어느 계열에 속하는지 모르겠어요
      </SearchModalButton> */}
    </Container>
  )
}

export default MajorSelector

const Container = styled(motion.div).attrs(() => ({
  variants: {
    hidden: { opacity: 0 },
    show: { opacity: 1 },
  },
  initial: "hidden",
  animate: "show",
  transition: { duration: 1 },
}))`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 20px;
`

// const SearchModalButton = styled(UnderlinedTextButton)`
//   align-self: flex-end;
//   text-align: end;
// `
